module.exports = __webpack_public_path__ + "static/sedemosmi-2a6fdbfd7ac0fc6278c4d497fde0c304.png";